import { Component, Input } from '@angular/core';

import { BuildingBlockInterface } from '../building-block.interface';
import { ImageSpotlightComponentContext } from './image-spotlight-context.interface';

@Component({
    templateUrl: './image-spotlight.component.html',
    styleUrls: ['./image-spotlight.component.min.css'],
})
export class ImageSpotlightComponent implements BuildingBlockInterface {
    @Input() public context: ImageSpotlightComponentContext;
    public paddingEnabled = false;
}



// WEBPACK FOOTER //
// /Users/tom/Projects/mercit2018/src/app/project/building-blocks/image-spotlight/image-spotlight.component.ts